<template>
  <router-view></router-view>
</template>

<script setup>
import Panel from '@/components/Panel.vue'
import { onMounted } from 'vue';
import {store} from '@/helper/store'
import { template } from '@/helper/value';


onMounted(() => {
  const local = window.location.pathname
  let lang = 'savedAUHTML'
   switch (local) {
    case '/': lang = 'savedAUHTML'; break;
    case '/KR': lang = 'savedKRHTML'; break;
    case '/TW': lang = 'savedTWHTML'; break;
    case '/MY': lang = 'savedMYHTML'; break;
    case '/SG': lang = 'savedSGHTML'; break;
    case '/JP': lang = 'savedJPHTML'; break;
   }
    const data = JSON.parse(localStorage.getItem(lang))?.data
    if(!data) return
        for(let i = data.length - 1; i >= 0; i--) {
          store.value.unshift(data[i])
          data[i].template = template.template
           data[i].view = template.view
            }
})

</script>

<style>

</style>
